import { nanoid } from 'nanoid'

const ASSET__ID_SIZE = 10

export const createAssetId = () => nanoid(ASSET__ID_SIZE)
